import type { SummaryItems, SummaryItemsWithEffectiveValue } from './ProfileSummaryItems.types';
import type { ProfileSummary } from '../../../types';

import { displayUsdValue } from '../ProfileSummary/ProfileSummary.helpers';

export function getItems(profileSummary: ProfileSummary): SummaryItems {
  return {
    interactedBlockchains: profileSummary.interactedBlockchains.toString(),
    invitedFriends: profileSummary.invitedFriends.toString(),
    referralVolume: displayUsdValue(profileSummary.referralVolume),
    referralIncome: displayUsdValue(profileSummary.referralIncome),
  };
}

export function getItemsWithEffectiveValue(
  profileSummary: ProfileSummary,
): SummaryItemsWithEffectiveValue {
  return {
    volume: {
      total: displayUsdValue(profileSummary.totalVolume),
      effective: displayUsdValue(profileSummary.totalVolumeEffective),
    },
    txCount: {
      total: profileSummary.txCount.toString(),
      effective: profileSummary.txCountEffective.toString(),
    },
  };
}
